import Gallery from './Gallery.svelte';
import Offline from './Offline.svelte';
import Graph from './Graph.svelte';
import Maple from './Maple.svelte';
import About from './About.svelte';
import Login from './Login.svelte';
import Forecast from './Forecast.svelte';
import FourOFour from './FourOFour.svelte';
import FiveHundred from './FiveHundred.svelte';
import Radar from './Radar.svelte';
import Bugs from './Bugs.svelte';
import SendPush from './SendPush.svelte';
import Router from "./router.js";
import { user, projections } from "./stores.js";
import { useLocalStorage } from "./storage.js";

useLocalStorage(user, "chaletapp-login");
useLocalStorage(projections, "chaletapp-projections");

const router = new Router({
    target: document.body,
    routes: {
      "": Graph,
      "#home": Graph,
      "#bugs": Bugs,
      "#maple": Maple,
      "#about": About,
      "#sensor": Graph,
      "#forecast": Forecast,
      "#radar": Radar,
      "#login": Login,
      "#camera": Gallery,
      "#push": SendPush,
      "#404": FourOFour,
      '#500': FiveHundred,
      "#offline": Offline
    }
  });
  
  window.addEventListener("hashchange", router.matchRoute, false);